import c from '../c';

export const buttonHoverStyles = 'hover:bg-accent-500 hover:ring-accent-500';
export const buttonHoverStylesWithUnderline = c(
  'hover:underline',
  buttonHoverStyles,
);

export const groupButtonHoverStyles =
  'group-hover:bg-accent-500 group-hover:ring-accent-500';
export const groupButtonHoverStylesWithUnderline = c(
  'group-button:underline',
  groupButtonHoverStyles,
);
